/* globals $, states_by_country, shipping_country_filter */

export function Setup_Addresses() {
    state_dropdown_swap($("#shipping-state"), $("#shipping-country"), states_by_country);
    state_dropdown_swap($("#billing-state"), $("#billing-country"), states_by_country);
    state_dropdown_swap($("#mailing-state"), $("#mailing-country"), states_by_country);
    copy_address_setup();
    clear_address_id();
}

function state_dropdown_swap(state, country, states_by_country) {
    var $state = $(state);
    var $current_state = $state;
    var $state_input = $state.clone();
    var $country = $(country);

    $country.on('change', function(ev) {
        updateStateField($(ev.currentTarget).val());
        showRequirementStatus(ev.currentTarget);
        showModalMessages($(ev.currentTarget).val());
        shippingCountryFilter();
    });

    updateStateField($country.val());
    showRequirementStatus($country);

    function showModalMessages(country) {
        // Donation Currency Message
        if ($("#camessage").length > 0 && country !== "US") {
            $("#camessage").modal();
        }
    }

    function showRequirementStatus(country) {
        const required_countries = ["US", "CA", ];
        $(country).closest(".ui-address").toggleClass("us", required_countries.includes($(country).val()));
    }


    function updateStateField(country) {
        var $new_state;
        if (typeof states_by_country[country] === 'object') {
            // Show state dropdown.
            $new_state = $('<select></select>');
            $new_state.attr({
                'class': $current_state.attr('class'),
                'id': $current_state.attr('id'),
                'name': $current_state.attr('name')
            });
            $new_state.append($('<option></option>'));
            $.each(states_by_country[country], function(index, state) {
                $new_state.append($('<option></option>').val(state[0]).html(state[1]));
            });
            $new_state.val($current_state.val());
        }
        else {
            // Show state input field.
            $new_state = $state_input.clone().val($current_state.val());
        }

        $current_state.replaceWith($new_state);
        $current_state = $new_state;
    }
}

export function shippingCountryFilter() {
    // Check for country selection
    var country = $("#shipping-country");
    if ($("#copy_address").is(":checked")) {
        country = $("#billing-country");
    }

    // Check if this is a shipping situation
    var wants_resource = $(".wants_donation_product:visible:checked").val();
    if ((wants_resource == '1' || wants_resource == '2' || $("#id_is_shippable").val()) &&
        ($(country).val() && shipping_country_filter.includes($(country).val()))) {
            // Display the modal
            $("#shipping-_change_link").click();
            $("#camessage").modal("hide");
            $("#shippingcountrydisplay").html($(country).find("option:selected").text());
            $("#shippingcountrymodal").modal();
            //    if ($("#copy_address").is(":checked")) {
            //        $("#copy_address").click();
            //    }
            //    $("#copy_address").attr('disabled', true)
            //    $("#shipping-country").val("");
    } 
    //else {
    //    $("#copy_address").attr('disabled', false)
    //}
}

function clear_address_id() {
    $(document).on("click", ".js-clear_shippingid", function() {
        $('input[name="shipping_address_id"]').each(function() {
            $(this).val("");
        })
    });
    $(document).on("click", ".js-clear_billingid", function() {
        $('input[name="billing_address_id"]').each(function() {
            $(this).val("");
        })
    });
}

function copy_address_setup() {
    $('.js-copy_picker').change(function(ev) {
        var checkbox = $(ev.target);
        var form = checkbox.closest('form');
        var shipping = form.find('.shipping-fields');

        // We disable the fields when hidden
        shipping.find('input, select').prop('disabled', checkbox.is(':checked'));
        shipping.toggle(!checkbox.is(':checked'));
    }).change();

    $("#copy_address").on("change", function() {
        shippingCountryFilter();
    });

}
